import { render, staticRenderFns } from "./PoliticasPage.vue?vue&type=template&id=adb24876&"
import script from "./PoliticasPage.vue?vue&type=script&lang=js&"
export * from "./PoliticasPage.vue?vue&type=script&lang=js&"
import style0 from "./PoliticasPage.vue?vue&type=style&index=0&id=adb24876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports